var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3031_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5104 49.6039C21.4792 48.92 21.5063 48.2403 21.7228 47.5854C22.2308 46.0627 23.2426 45.0049 24.7499 44.4326C25.3224 44.2157 25.9283 44.1351 26.5424 44.1351C35.553 44.1351 44.5657 44.1269 53.5763 44.1434C55.1856 44.1455 56.5055 44.821 57.4944 46.102C57.965 46.7115 58.2606 47.3932 58.4042 48.1432C58.5396 48.8498 58.4938 49.5688 58.4771 50.2795C58.4542 51.2691 58.2835 52.2381 57.9899 53.1884C57.5631 54.5644 56.8699 55.7875 55.9351 56.8783C54.9857 57.9837 53.8532 58.8721 52.5915 59.6096C51.5089 60.2418 50.3701 60.7439 49.1813 61.1385C48.4651 61.3761 47.7385 61.5785 46.9995 61.7459C46.2791 61.9091 45.5567 62.0517 44.828 62.1612C44.0369 62.2789 43.2416 62.3616 42.4421 62.4132C41.3637 62.4814 40.2852 62.5186 39.2068 62.4876C38.4406 62.4649 37.6745 62.4463 36.9104 62.3678C36.238 62.2996 35.5655 62.2128 34.8972 62.1116C34.0332 61.9793 33.1796 61.8058 32.3323 61.5909C31.6452 61.4174 30.9686 61.1984 30.3003 60.9587C29.1344 60.5393 28.0206 60.0125 26.9692 59.3555C26.1177 58.8245 25.3266 58.2171 24.6229 57.5043C23.5549 56.4218 22.7179 55.1821 22.1808 53.7566C21.829 52.8207 21.627 51.8496 21.5375 50.8518C21.5 50.4344 21.5167 50.0171 21.5063 49.5997L21.5104 49.6039Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9771 41.0217C33.4669 41.0568 28.1226 35.7864 28.1309 29.2557C28.1372 22.756 33.4503 17.4484 40.0916 17.5C46.5747 17.5496 51.8586 22.7374 51.8628 29.2639C51.8649 35.8215 46.4998 41.0733 39.9771 41.0217Z",
    fill: "#8F8F8F"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#707070"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3031_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 45,
    fill: "white",
    transform: "translate(21.5 17.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/default-user.948f91c559878b71724363af2761b228.svg";
export { ForwardRef as ReactComponent };